import {AbstractControl, FormControl, ValidatorFn} from '@angular/forms';

export function isObjectValidator(control: FormControl) {
  return (typeof control.value === 'object') ? null : {
    isObject: true
  };
}
